import React, { createContext, useContext, useState, useEffect } from "react";

//Firebase
import { GoogleFirebase, auth, firestore } from "../config/config";

//Context
import { AuthContext } from "./AuthContext";
import { ExcelContext } from "./ExcelContext";

// Context
export const AgentContext = createContext();
export const AgentActionContext = createContext();

const AgentContextProvider = (props) => {
  const { user } = useContext(AuthContext);
  const { readExcel, exportToExcel } = useContext(ExcelContext);

  const [agents, setAgents] = useState({});
  const [team, setTeam] = useState({});
  const [agentsCount, setAgentsCount] = useState(0);

  //Recaptcha Work
  const setUpRecaptcha = () => {
    window.recaptchaVerifier = new GoogleFirebase.auth.RecaptchaVerifier(
      "recaptcha-container",
      {
        size: "invisible",
        callback: (response) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          registerAgent();
        },
      },
    );
  };

  //Agents Registration
  const registerAgent = (
    name,
    phoneNo,
    email,
    address,
    setAlertTitle,
    setErr,
    setSuccess,
  ) => {
    firestore
      .collection("agents")
      .where("phoneNo", "==", phoneNo)
      .where("agencyID", "==", user.uid)
      .get()
      .then((doc) => {
        if (!doc.empty) {
          popUp(
            setAlertTitle,
            "User Already Exists!",
            setErr,
            `The user containing ${phoneNo} phone number already exist in database!`,
          );
        } else {
          const appVerifier = window.recaptchaVerifier;

          auth
            .signInWithPhoneNumber(phoneNo, appVerifier)
            .then((confirmationResult) => {
              window.confirmationResult = confirmationResult;
              const code = window.prompt(
                `We had sent you a code on ${phoneNo}. Enter that code here:`,
              );
              confirmationResult
                .confirm(code)
                .then((result) => {
                  // Add document
                  const agent = result.user;
                  firestore
                    .collection("agents")
                    .doc(agent.uid)
                    .set({
                      avatar: "",
                      name: name,
                      phoneNo: agent.phoneNumber,
                      email: email,
                      address: address,
                      id: agent.uid,
                      agencyID: user.uid,
                    })
                    .then(() => {
                      popUp(
                        setAlertTitle,
                        "Agent Inserted!",
                        setSuccess,
                        `${name} added as agent in your agency successfully.`,
                      );
                    })
                    .catch((error) => {
                      popUp(
                        setAlertTitle,
                        "Error writing document!",
                        setErr,
                        error.message,
                      );
                    });
                })
                .catch((error) => {
                  popUp(setAlertTitle, error.code, setErr, error.message);
                });

              // ...
            })
            .catch((error) => {
              popUp(setAlertTitle, error.code, setErr, "--> " + error.message);
            });
        }
      });
  };

  //Alert Popup
  const popUp = (setTitle, title, setMsg, msg) => {
    setTitle(title);
    setMsg(msg);
    setTimeout(() => {
      setTitle("");
      setMsg("");
    }, 10000);
  };

  //Handle Excel
  const uploadedExcel = (obj) => {
    const sortedObj = [];

    obj.map((data) => {
      return firestore
        .collection("agents")
        .where("phoneNo", "==", data.phoneNo)
        .get()
        .then((doc) => {
          if (doc.empty) {
            sortedObj.push(data);
          }
        });
    });

    setAgents(sortedObj);
  };

  const fileHeader = ["name", "phoneNo", "email", "address"];
  const readFile = (file, Alert) => {
    readExcel(file, uploadedExcel, Alert, fileHeader);
  };

  const demoAgentFile = () => {
    exportToExcel([fileHeader], "Demo Agents File");
  };

  useEffect(() => {
    //--> Working
    if (user.uid !== undefined) {
      firestore
        .collection("agents")
        .where("agencyID", "==", user.uid)
        .onSnapshot((docSnap) => {
          setTeam(
            docSnap.docs.map((agent) => {
              return {
                avatar: agent.data().avatar,
                name: agent.data().name,
                phoneNo: agent.data().phoneNo,
                email: agent.data().email,
                address: agent.data().address,
                id: agent.data().id,
              };
            }),
          );

          setAgentsCount(0);
          docSnap.docs.map(() => {
            return setAgentsCount((prev) => prev + 1);
          });
        });
    }
  }, [user.uid]);

  const agentsDetails = (id, state) => {
    if (id) {
      firestore
        .collection("agents")
        .doc(id)
        .onSnapshot((doc) =>
          state({ name: doc.data().name, avatar: doc.data().avatar }),
        );
    }
  };

  const removeAgent = (phoneNo) => {
    setAgents(agents.filter((data) => data.phoneNo !== phoneNo));
  };

  return (
    <AgentContext.Provider value={{ agents, team, agentsCount }}>
      <AgentActionContext.Provider
        value={{
          setUpRecaptcha,
          registerAgent,
          readFile,
          demoAgentFile,
          removeAgent,
          agentsDetails,
        }}
      >
        {props.children}
      </AgentActionContext.Provider>
    </AgentContext.Provider>
  );
};

export default AgentContextProvider;
